let cachedPublicKeyPromise = null;
let cachedPrivateKeyPromise = null;

const rsaOaepAlgorithm = {
	name: "RSA-OAEP",
	hash: "SHA-256",
};

function base64ToArrayBuffer(base64) {
	const sanitized = (base64 || "").replace(/\s/g, "");
	const binary = atob(sanitized);
	const bytes = new Uint8Array(binary.length);
	for (let i = 0; i < binary.length; i += 1) {
		bytes[i] = binary.charCodeAt(i);
	}
	return bytes.buffer;
}

function arrayBufferToBase64(buffer) {
	const bytes = new Uint8Array(buffer);
	let binary = "";
	const chunkSize = 0x8000;
	for (let i = 0; i < bytes.length; i += chunkSize) {
		const chunk = bytes.subarray(i, i + chunkSize);
		binary += String.fromCharCode(...chunk);
	}
	return btoa(binary);
}

async function getPublicKey() {
	if (!cachedPublicKeyPromise) {
		const publicKeyDerBase64 = process.env.REACT_APP_PUBLIC_CKEY;
		if (!publicKeyDerBase64) {
			throw new Error("Missing REACT_APP_PUBLIC_CKEY");
		}
		cachedPublicKeyPromise = crypto.subtle.importKey(
			"spki",
			base64ToArrayBuffer(publicKeyDerBase64),
			rsaOaepAlgorithm,
			false,
			["encrypt"]
		);
	}
	return cachedPublicKeyPromise;
}

async function getPrivateKey() {
	if (!cachedPrivateKeyPromise) {
		const privateKeyDerBase64 = process.env.REACT_APP_RESET_PWD_PRIVATE_CKEY;
		if (!privateKeyDerBase64) {
			throw new Error("Missing REACT_APP_RESET_PWD_PRIVATE_CKEY");
		}
		cachedPrivateKeyPromise = crypto.subtle.importKey(
			"pkcs8",
			base64ToArrayBuffer(privateKeyDerBase64),
			rsaOaepAlgorithm,
			false,
			["decrypt"]
		);
	}
	return cachedPrivateKeyPromise;
}

export async function rsaOaepEncrypt(plaintext) {
	// 目前PUBLIC_KEY是1024位，只支持輸入62個字符進行加密
	const publicKey = await getPublicKey();
	const plainBytes = new TextEncoder().encode(String(plaintext ?? ""));
	const encrypted = await crypto.subtle.encrypt({ name: "RSA-OAEP" }, publicKey, plainBytes);
	return arrayBufferToBase64(encrypted);
}

export async function rsaOaepDecrypt(plaintext) {
	try {
		const privateKey = await getPrivateKey();
		const cipherBytes = base64ToArrayBuffer(String(plaintext ?? ""));
		const decrypted = await crypto.subtle.decrypt({ name: "RSA-OAEP" }, privateKey, cipherBytes);
		return new TextDecoder().decode(decrypted);
	} catch (error) {
		console.error("解密失败:", error);
		throw error;
	}
}
